import { SVGProps } from 'react';

export function InfIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			width={props.width ? props.width : '45'}
			height={props.height ? props.height : '19'}
			viewBox='0 0 45 19'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M22.4468 9.49961C25.619 6.50833 30.3477 1 35.2311 1C40.1145 1 44.0733 4.8054 44.0733 9.49961C44.0733 14.1938 40.1145 17.9992 35.2311 17.9992C32.1079 17.9992 29.3629 16.4427 27.7898 14.0925'
				stroke='#252F35'
				strokeWidth='1.3'
			/>
			<path
				d='M22.4497 9.49997C19.2008 12.5612 14.5488 17.9996 9.66535 17.9996C4.78195 17.9996 0.823166 14.1942 0.823166 9.49997C0.823166 4.80576 4.78195 1.00036 9.66535 1.00036C12.7886 1.00036 15.5336 2.55692 17.1067 4.90704'
				stroke='#252F35'
				strokeWidth='1.3'
			/>
		</svg>
	);
}
